$(function () {
	$('.b-h__btn_search').on('click', function (event) {
		$('.b-h__item_center').addClass('b-h__item_center_opened');
		$('.b-h__item_center input[type=text]').focus();
		$('.body').addClass('_overflow');
	});
});

$(function () {
	if ($(window).width() > 991) {
		$('.b-h__catalog').on('click', function () {
			$('.b-catalogMenu').slideToggle();
			$(this).toggleClass('b-h__catalog_opened');
		});

		$(document).on('click', function (e) {
			if (!$(e.target).closest(".b-h__catalog-wrap").length) {
				$('.b-catalogMenu').slideUp();
				$('.b-h__catalog').removeClass('b-h__catalog_opened');
			}
			e.stopPropagation();
		});
	}
});

$(function () {
	$('#mobileBtn').on('click', function () {
		$('.b-sidebar .b-catalogMenu').addClass('b-catalogMenu_opened');
	});

	$('.b-catalogMenu__back_mobile').on('click', function () {
		$('.b-catalogMenu').removeClass('b-catalogMenu_opened');
	});
});

$(function () {
	$('[data-toggle="menu"]').on('click', function () {

		if ($('.body').hasClass('_overflow')) {
			$('.body').removeClass('_overflow');
			$('.b-burger').removeClass('b-burger_active');
			$('.b-sidebar').removeClass('b-sidebar_opened');
		} else {
			$('.body').toggleClass('_overflow');
			$('.b-burger').addClass('b-burger_active');
			$('.b-sidebar').addClass('b-sidebar_opened');
		}
	});
});

$(function () {
	$('.overlay').on('click', function () {
		$('.body').removeClass('_overflow');
		$('.b-h__item_center').removeClass('b-h__item_center_opened');
		$('.b-burger').removeClass('b-burger_active');
		$('.b-sidebar').removeClass('b-sidebar_opened');
	});
});

$(function () {
	$(window).scroll(function () {
		if ($(this).scrollTop() > 1000) {
			$('.b-btn_scroll').fadeIn().css('animation-name', 'rotLeft');
		} else {
			$('.b-btn_scroll').css('animation-name', 'rotRight').fadeOut();
		}
	});

	$('.b-btn_scroll').click(function () {
		$("html, body").animate({
			scrollTop: 0
		}, 600);
		return false;
	})
});

$(function () {
	$('#filterBtn').on('click', function () {
		$('.b-catalog__filterPanel').addClass('b-catalog__filterPanel_opened');
		$('.body').hasClass('_overflow');
	});

	$('#closeFilterBtn').on('click', function () {
		$('.b-catalog__filterPanel').removeClass('b-catalog__filterPanel_opened');
		$('.body').removeClass('_overflow');
	});

	/**
	 * При применении/сбросе фильтра закрывать мобильную версию
	 */
	BX.addCustomEvent("CatalogSectionDefault:filter", () => {
		$("#closeFilterBtn").trigger("click");
	});
});

$(function () {
	$("a.b-detail__rating").click(function () {
		let elementClick = $(this).attr("href");
		let destination = $(elementClick).offset().top - 100;
		$("html:not(:animated),body:not(:animated)").animate({scrollTop: destination}, 800);

		if ($(window).width() <= 768) {
			deactivateTab();
			$(document.querySelector("#reviews-mobile-anchor")).addClass('b-tabs__link_active').children('.b-tabs__icon').addClass('b-tabs__icon_active');
			$(document.querySelector("#reviews-mobile-anchor")).siblings().addClass('b-tabs__content_active').slideDown();
		} else {
			document.querySelector("#reviews-anchor").click();
		}

		return false;
	});

	$('.b-tabs__link_desktop').first().addClass('b-tabs__link_active');
	$('.b-tabs__content_desktop').first().addClass('b-tabs__content_active');

	activateDesktopTab();

	if ($(window).width() <= 768) {
		deactivateTab();
	}

	activateMobileTab();

	function activateDesktopTab() {
		var $tabLinks = $('.b-tabs__link_desktop'),
			$tabContents = $('.b-tabs__content_desktop');

		$tabLinks.on('click', function (event) {

			event.preventDefault();
			if ($(this).hasClass('b-tabs__link_active')) return;

			$tabLinks.removeClass('b-tabs__link_active');
			$(this).addClass('b-tabs__link_active');

			var index = $(this).index();

			$tabContents.find('.b-list_points').removeClass('b-list_points_full');
			$tabContents.find('.b-tabs__btn_more').html($('.b-tabs__btn_more').data('titleShow'));
			$tabContents.removeClass('b-tabs__content_active');
			$tabContents.eq(index).addClass('b-tabs__content_active');
		});
	}

	function activateMobileTab() {
		$(".b-tabs__link_mobile").click(function (event) {
			if ($(this).hasClass('b-tabs__link_active')) {
				deactivateTab();
			} else {
				deactivateTab();
				$(this).addClass('b-tabs__link_active').children('.b-tabs__icon').addClass('b-tabs__icon_active');
				$(this).siblings().addClass('b-tabs__content_active').slideDown();
			}
		});
	}

	function deactivateTab() {
		$('.b-tabs__link_mobile').removeClass('b-tabs__link_active').children('.b-tabs__icon').removeClass('b-tabs__icon_active');
		$('.b-tabs__link_mobile').siblings().removeClass('b-tabs__content_active').slideUp();
	}
});

//открытие меню в Новостях
$(function () {
	if ($(window).width() <= 768) {

		$('#menu-news__btn').on('click', function () {
			$(this).toggleClass('b-newsPage__nav_active');
			$('.b-newsPage__menu').toggleClass('b-newsPage__menu_opened');
		});

		$(document).mouseup(function (e){
			let div = $("#menu-news__btn");
			if (!div.is(e.target) && div.has(e.target).length === 0 && div.hasClass('b-newsPage__nav_active')) {
				div.removeClass('b-newsPage__nav_active');
				$('.b-newsPage__menu').removeClass('b-newsPage__menu_opened');
			}
		});
	}
});

var citrusMapIcon = {
	href: "/local/templates/main/app/assets/dist/img/mapPoint.svg",
	size: [47, 57],
}
